const dailyStatsController = (app) => {
  app.get("/*", async ({ req, locals, load }, next) => {
    const { query = {} } = req;
    await Promise.all([
      load("dailyStats", {
        proxyAthlete: query.athlete,
      }),
      load("nutritionPlans", {
        proxyAthlete: query.athlete,
      }),
    ]);
    return next();
  });
};

export default dailyStatsController;
